import type { App as VueApp } from 'vue';
import type { Router } from 'vue-router';
import * as Sentry from '@sentry/vue';

function parseSampleRate(value: string | undefined): number | undefined {
  if (!value) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function initSentry(app: VueApp, router: Router): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || undefined,
    release: import.meta.env.VITE_SENTRY_RELEASE || __GIT_COMMIT_FULL__,
    dist: __BUILD_TIME__,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.vueIntegration({
 app,
tracingOptions: { trackComponents: true },
}),
    ],
    sendDefaultPii: false,
    initialScope: {
      tags: {
        git_commit: __GIT_COMMIT_FULL__,
        git_branch: __GIT_BRANCH__,
        build_time: __BUILD_TIME__,
      },
    },
    tracesSampleRate: parseSampleRate(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) ?? 0,
  });
}

/**
 * `apiKey`/`sessionKey` are Hydrus API credentials held in the `api` Pinia store;
 * `fileUrls` embeds the session key in every image URL. Strip/collapse them so
 * captured store state sent to Sentry/Bugsink never carries live credentials.
 */
export function sentryPiniaPlugin() {
  return Sentry.createSentryPiniaPlugin({
    stateTransformer: (state) => {
      const { apiKey, sessionKey, fileUrls, ...safe } = state as Record<string, unknown>;
      return {
        ...safe,
        ...(fileUrls !== undefined
          ? { fileUrls: Array.isArray(fileUrls) ? fileUrls.length : fileUrls }
          : {}),
      };
    },
  });
}
